import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const TwitterDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 324" transform="translate(-586.53 -168.336)">
      <rect
        data-name="\u9577\u65B9\u5F62 776"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(586.53 168.336)"
      />
      <path data-name="\u9577\u65B9\u5F62 777" fill="#424242" d="M592.811 207.989h132.072v202.694H592.811z" />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 323">
        <path
          data-name="\u30D1\u30B9 1029"
          d="M724.8 207.989v-18.011a14.31 14.31 0 00-14.309-14.309H696.37v1.918a7.586 7.586 0 01-7.586 7.587h-59.117a7.586 7.586 0 01-7.586-7.587v-1.918h-14.962a14.309 14.309 0 00-14.308 14.309v18.011z"
          fill="#424242"
        />
      </g>
      <path
        data-name="\u30D1\u30B9 1030"
        d="M592.811 411.73v35.845a14.308 14.308 0 0014.308 14.308h103.374a14.309 14.309 0 0014.307-14.308V411.73z"
        fill="#fff"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 778"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(640.236 454.36)"
      />
      <path data-name="\u7DDA 4" fill="none" stroke="#f5f5f5" strokeMiterlimit={10} d="M592.987 411.338h131.654" />
      <circle
        data-name="\u6955\u5186\u5F62 463"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(711.073 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 464"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(674.189 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 465"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(635.57 435.779)"
        fill="#9e9e9e"
      />
      <circle
        data-name="\u6955\u5186\u5F62 466"
        cx={4.773}
        cy={4.773}
        r={4.773}
        transform="translate(598.686 435.779)"
        fill="#1ba1f4"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 779"
        width={116.48}
        height={11.384}
        rx={5.692}
        transform="translate(599.934 418.139)"
        fill="#e7e7e7"
      />
    </g>
  </Root>
);

const Root = styled('svg')();

export default TwitterDevice916;
